<template>
  <label class="switch" :style="{ '--customColor': color }">
    <input type="checkbox" :checked="value" @change="$emit('change', $event)" />
    <span class="slider round" :class="{ 'custom-color': color }"></span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: true
    },
    color: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
  margin-bottom: 0;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  height: 100%;
}

.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $defaultColor;
}

.merch input:checked + .slider {
  background-color: $merchColor;
}

.design input:checked + .slider {
  background-color: $designColor;
}

input:checked + .slider.custom-color {
  background-color: var(--customColor);
}

input:checked + .slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  box-shadow: 0px 0px 10px #0000003b;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
